import * as Sentry from '@sentry/react';

const addSentryTimeoutInterceptor = client => {
  client.interceptors.response.use(
    response => response,
    error => {
      if (error.code === 'ECONNABORTED') {
        Sentry.captureException(new Error('Axios request timed out'), {
          extra: {
            url: error.config.url,
            method: error.config.method,
            data: error.config.data,
          },
        });
      }
      return Promise.reject(error);
    },
  );

  return client;
};

export default addSentryTimeoutInterceptor;
